var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"tipo-passe","rota-base":"/admin/tipo-passe","titulo-singular":"Tipo de Passe","campos-extras":[{ campo: 'descricao', label: 'Descrição', tipo: 'text', span: 24 }]}})
}
var staticRenderFns = []

export { render, staticRenderFns }